<template>
  <transition :name="transitionName">
    <n-layout v-if="visible" class="chat-client" :style="attrStyle" vertical @on-drag-end.native="onDragEnd">
      <template #header>
        <n-drag class="chat-client-header flex-row" draggable target="chat-client">
          <h2 class="chat-client-title">AI小助手 - 测试版</h2>
          <n-icon class="chat-client-close" type="x" size="24" scene="default" @click.stop="visible = false" />
        </n-drag>
      </template>
      <chat-client-messages :room_id="room_id" :messages="messages" @send-retry-message="sendRetryMessage" />
      <div v-if="messages.length <= 0" class="chat-client-placeholder">
        <p>我是AI小助手，您的智能小助理。 </p>
        <p>我目前的能力有限，有时可能会不小心出错。</p>
        <p>您可以提供你宝贵的建议，帮助我变得更好。</p>
      </div>
      <template #footer>
        <div class="chat-client-footer">
          <div class="chat-bar flex-row">
            <n-select-filter label="AI模型" :options="models" :clearable="false" v-model="model" @u-change="onModelChange" />
<!--            <div class="chat-bar-tip flex-1">-->
<!--              <span>AI小助手生成的内容不一定准确，请注意核查！</span>-->
<!--              <a class="btn-blue" href="https://shimo.im/docs/913JMyemVWiw5mAE" target="_blank">查看帮助</a>-->
<!--            </div>-->
          </div>
          <n-input type="textarea" v-model="messageText" :rows="4"
                   placeholder="请输入内容与AI小助手交流，按 Shift + Enter 换行，按 Enter 发送"
                   @keyup.enter="onInputEnter" />
          <n-button size="small" type="primary" :disabled="loading" @click="sendMessageByInput">发送</n-button>
        </div>
      </template>
    </n-layout>
  </transition>
</template>

<script>
import request from './request'
import {scrollToBottom, getCurrentModelValue, getModelsOptions} from './tools'
import ChatClientMessages from './chat-client-messages.vue'

export default {
  name: 'chat-client',
  components: {
    ChatClientMessages
  },
  data () {
    return {
      // 动画
      transitionName: 'hide-right',
      attrStyle: null,
      visible: false,
      // room
      room_id: '',
      // 模型
      models: [],
      model: '',
      // 消息
      offset: 0, // 服务器与客户端 时间差
      messageText: '',
      loading: false,
      messages: []
    }
  },

  watch: {
    visible (value, oldValue) {
      if (oldValue && !value) {
        this.addTimeLine(0, { type: 1000 })
      }
    }
  },

  methods: {
    // 开启新对话
    async start ({ room_title }) {
      this.room_id = ''
      this.messageText = ''
      this.messages = []
      this.visible = true
      this.loading = true
      const params = {
        room_title,
        from_source: this.$route?.name
      }
      const {data, timestamp} = await request('/api/chat/create_room', params)
      if (timestamp) {
        this.offset = timestamp - +new Date()
      }
      this.room_id = data.id
      // 模型
      this.models = getModelsOptions(data.models)
      await this.$nextTick()
      this.model = getCurrentModelValue(this.models, localStorage.getItem('AICHAT_MODEL'))
      this.loading = false
      this.addTimeLine(0, {type: 1})
    },

    // 发送聊天消息
    async sendMessage({message_text, options}) {
      // 统计时间戳
      const timestamp = {
        send: 0,
        startRender: 0,
        finishRender: 0,
        finished: false
      }
      this.loading = true
      // human 消息
      const humanMessage = {role: 'human', content: message_text, options, type: 1}
      this.messages.push(humanMessage)
      // ai 消息
      const aiMessage = {role: 'ai', content: '', loading: true}
      this.messages.push(aiMessage)
      // 打字机
      const typewriter = new tools.Typewriter((content) => {
        this.$set(aiMessage, 'content', content)
        // 记录时间戳
        if (!timestamp.startRender) {
          timestamp.startRender = +new Date()
        }
        if (timestamp.finished && !typewriter.remainText) {
          timestamp.finishRender = +new Date()
          this.addTimeLine(humanMessage?.id, [
            {
              // Send
              type: 100,
              timestamp: timestamp.send
            },
            {
              // StartRender
              type: 400,
              timestamp: timestamp.startRender
            },
            {
              // FinishRender
              type: 490,
              timestamp: timestamp.finishRender
            }
          ])
        }
      })
      // nextTick 保证元素已渲染
      await this.$nextTick()
      const cancelScroll = scrollToBottom(this.$el.querySelector('.n-chat-history'))
      // 发送请求
      const body = {room_id: this.room_id, message_text, options, model: this.model}
      // 发送时间戳
      timestamp.send = +new Date()
      await request('/api/chat/send_message', body, {
        stream: true,
        // json 回复
        onJson: ([msg1, msg2]) => {
          this.$set(humanMessage, 'id', msg1?.id)
          this.$set(aiMessage, 'id', msg2?.id)
          this.$set(aiMessage, 'content', msg2?.content)
          setTimeout(() => cancelScroll())
        },
        // 流式响应
        onStream: (chunk) => {
          if (chunk.startsWith('data:')) {
            // 数据
            const message = tools.jsonParse(chunk.substring(5))
            switch (message?.type) {
              case 'chunk':
                typewriter.append(message.content)
                return true
              case 'finish':
                this.$set(humanMessage, 'id', message.content[0].id)
                this.$set(aiMessage, 'id', message.content[1].id)
                timestamp.finished = true
                setTimeout(() => cancelScroll(), 3000)
                return true
              case 'error':
                this.$set(aiMessage, 'content', message.content)
                this.$set(aiMessage, 'isError', true)
                this.$set(humanMessage, 'isError', true)
                setTimeout(() => cancelScroll())
                return true
            }
            // 附加内容的字段：additional_kwargs.prefetch
            if (message?.additional_kwargs?.prefetch) {
              typewriter.append(message.additional_kwargs.prefetch)
            }
            if (message?.content) {
              typewriter.append(message.content)
            }
            // 附加内容的字段：additional_kwargs.attach
            if (message?.additional_kwargs?.attach) {
              typewriter.append(message.additional_kwargs.attach)
            }
          }
          // 数据
          if (chunk.startsWith('event: [DONE]:')) {
            const [msg1, msg2] = tools.jsonParse(chunk.replace(/^event: \[DONE]:/, '')) || []
            this.$set(humanMessage, 'id', msg1?.id)
            this.$set(aiMessage, 'id', msg2?.id)
            timestamp.finished = true
            setTimeout(() => cancelScroll(), 3000)
          }
          // 数据
          if (chunk.startsWith('event: [ERROR]:')) {
            const text = chunk.replace(/^event: \[ERROR]:/, '')
            this.$set(aiMessage, 'content', text)
            this.$set(aiMessage, 'isError', true)
            this.$set(humanMessage, 'isError', true)
            setTimeout(() => cancelScroll())
          }
        }
      }).catch(async response => {
        let text = '服务器连接失败, 请联系管理员'
        try {
          const result = await response.clone().text()
          text = [text, result].join('\n\n')
        } catch {
        }
        this.$set(aiMessage, 'content', text)
        this.$set(aiMessage, 'isError', true)
        this.$set(humanMessage, 'isError', true)
        setTimeout(() => cancelScroll())
      })
      this.$set(aiMessage, 'loading', false)
      this.loading = false
    },
    // 重试
    sendRetryMessage({content, options}) {
      this.sendMessage({message_text: content, options})
    },
    onInputEnter(event) {
      if (!event.shiftKey && !event.ctrlKey) {
        this.sendMessageByInput()
      }
    },
    // 发送输入消息
    sendMessageByInput() {
      this.messageText = tools.trim(this.messageText)
      if (this.room_id && this.messageText && !this.loading) {
        this.sendMessage({message_text: this.messageText})
        this.messageText = ''
      }
    },
    // 更新动画
    onDragEnd(event) {
      const {left, right} = event.currentTarget.getBoundingClientRect()
      this.transitionName = left > window.innerWidth - right ? 'hide-right' : 'hide-left'
      this.attrStyle = event.currentTarget.getAttribute('style')
    },
    onModelChange(value) {
      localStorage.setItem('AICHAT_MODEL', value)
      uif.toast.success('AI模型切换成功，在下次对话时生效！')
    },
    // 添加时间线
    addTimeLine(message_id, data) {
      const times = tools.normalizeArray(data)
      times.forEach(data => {
        if (!data.timestamp) {
          data.timestamp = +new Date() + this.offset
        }
      })
      request('/api/chat/add_time_line', {room_id: this.room_id, message_id, times}, {silence: true}).catch(() => 0)
    }
  }
}
</script>

<style scoped lang="scss">
.chat-client{
  top: 10vh;
  right: 10vh;
  width: 520px;
  height: 80vh;
  position: absolute;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(22, 22, 22, 0.4);
  &-header {
    height: 40px;
    padding: 0 12px;
    border-radius: 8px 8px 0 0;
    background: linear-gradient(180deg, #FFFFFF 0%, #F0F3F6 100%);
  }
  &-title{
    font-size: 14px;
    line-height: 22px;
    color: #161616;
    font-weight: bold;
    margin-right: auto;
  }
  &-placeholder {
    color: #919293;
    text-align: center;
    padding: 40px;
    font-size: 14px;
    line-height: 2em;
  }
  &-footer {
    position: relative;
    padding: 8px 12px 12px;
    .n-btn {
      right: 18px;
      bottom: 18px;
      position: absolute;
    }

    ::v-deep(.n-input .n-form-value) {
      padding-right: 50px;
    }
  }
}

::v-deep(.n-chat-history-trigger) {
  display: none;
}

.chat-bar {
  gap: 4px;
  margin-bottom: 4px;
  .n-select {
    width: 100px;
  }
  &-tip {
    color: #23a609;
    padding: 2px 8px;
    line-height: 24px;
    border-radius: 4px;
    background-color: #d9f6d5;
  }
}
</style>
